import { createSlice } from '@reduxjs/toolkit'
import { setNestedKey } from '../../../helpers/common'
import { register } from '../../../helpers/reducerRegistry'
import { TYPE_SORT, TYPE_SORT_FOLLOWING_LIST } from '../../constant'
import { handleSelectAllIdInTable } from '../../helper'
import { convertDataTableRedux, getListId } from '../helper'
import {
  getAllIdFollow,
  getHeaderFollow,
  getSearchCompanyInFollowList,
} from './thunk'

const initialState = {
  ids: [],
  dataReduxTable: {},
  selectCheckBox: {
    listIdsSelected: {},
    listIdAllByTerm: [],
  },
  isLoading: {
    table: true,
    getAllId: true,
  },
  filter: {
    term: '',
    page: 1,
    pageSize: 20,
    sort: TYPE_SORT_FOLLOWING_LIST.DELIVERY_DATE_ID,
    sortDirection: TYPE_SORT.DESCENDING,
    totalRecords: 0,
  },
  totalItems: 0,
}

const slice = createSlice({
  name: 'library/followingList',
  initialState,
  reducers: {
    resetStore(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    changeFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload }
    },
    changeCheckboxTable: (state, action) => {
      const { path, data } = action.payload
      setNestedKey(state.selectCheckBox, path, data)
    },
    selectAllIdInTable: (state, action) => {
      state.selectCheckBox.listIdsSelected = handleSelectAllIdInTable(
        state.selectCheckBox.listIdsSelected,
        state.ids,
        action.payload,
      )
    },
    selectAllIdByTerm: (state, action) => {
      state.selectCheckBox.listIdsSelected = handleSelectAllIdInTable(
        state.selectCheckBox.listIdsSelected,
        state.selectCheckBox.listIdAllByTerm,
        action.payload,
      )
    },
    unSelectAllCheckbox: (state) => {
      state.selectCheckBox.listIdsSelected = {}
    },
    removeIdInListIdAll: (state, action) => {
      state.selectCheckBox.listIdAllByTerm =
        state.selectCheckBox.listIdAllByTerm.filter(
          (item) => !action.payload.includes(item),
        )
    },
  },
  extraReducers: (builder) => {
    //getSearchCompanyInFollowList
    builder.addCase(getSearchCompanyInFollowList.pending, (state, action) => {
      state.isLoading.table = true
    })
    builder.addCase(getSearchCompanyInFollowList.fulfilled, (state, action) => {
      state.filter = {
        ...state.filter,
        term: action.meta.arg?.term,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        totalRecords: action.payload.totalRecords,
      }
      state.ids = getListId(action.payload.data)
      state.dataReduxTable = convertDataTableRedux(action.payload.data)
      state.isLoading.table = false
    })
    builder.addCase(getSearchCompanyInFollowList.rejected, (state, action) => {
      state.isLoading.table = action.payload.loading
      state.ids = []
      state.dataReduxTable = {}
    })
    //getHeaderFollow
    builder.addCase(getHeaderFollow.fulfilled, (state, action) => {
      state.totalItems = action.payload || 0
    })
    //getAllIdFollow
    builder.addCase(getAllIdFollow.pending, (state, action) => {
      state.isLoading.getAllId = true
    })
    builder.addCase(getAllIdFollow.fulfilled, (state, action) => {
      state.selectCheckBox.listIdAllByTerm = action.payload
      state.isLoading.getAllId = false
    })
    builder.addCase(getAllIdFollow.rejected, (state, action) => {
      state.isLoading.getAllId = action.payload.loading
    })
  },
})

//table
export const selectIdsTableFollowingList = (state) => state[slice.name].ids

export const getDataTableFollowingListFromRedux = (rowId, colId) => (state) =>
  state[slice.name].dataReduxTable[rowId][colId]

export const selectDataTableFollowingList = (state) =>
  state[slice.name].dataReduxTable

//get filter
export const selectFilterTableFollowingList = (type) => (state) =>
  type ? state[slice.name].filter[type] : state[slice.name].filter

//checkbox Table
export const selectDataCheckBox = (type) => (state) =>
  state[slice.name].selectCheckBox[type]

export const selectCheckboxFollow =
  (attr = [], callback) =>
  (state) => {
    const data = attr.reduce(
      (result, key) => result[key],
      state[slice.name].selectCheckBox,
    )
    return callback ? callback(data) : data
  }

//get loading
export const getLoadingFollowingList = (type) => (state) =>
  state[slice.name].isLoading[type]

export const getTotalItem = (state) => state[slice.name].totalItems

export const {
  changeFilter,
  resetStore,
  changeCheckboxTable,
  selectAllIdInTable,
  selectAllIdByTerm,
  unSelectAllCheckbox,
  removeIdInListIdAll,
} = slice.actions

register(slice.name, slice.reducer)
